type Options =
  | {
      type: "data";
      data: any;
    }
  | {
      type: "href";
      href: string;
    };

export const downloadFile = (fileName: string, options: Options) => {
  const href =
    options.type === "href" ? options.href : URL.createObjectURL(options.data);

  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  if (options.type === "data") {
    URL.revokeObjectURL(href);
  }
};
